import { render, staticRenderFns } from "./PictureCreate.vue?vue&type=template&id=a3687360&"
import script from "./PictureCreate.vue?vue&type=script&lang=js&"
export * from "./PictureCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports